module.exports = __webpack_public_path__ + "static/android-icon-192x192-29e3603a1321cec2461d3561a46c974d.png";